/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { GetApiBookingId200, GetApiBookingIdPathParams, GetApiBookingIdQueryParams, GetApiBookingIdQueryResponse } from "../entities/GetApiBookingId";
import { modelsAppointmentSchema } from "./models/appointmentSchema";
import { z } from "zod/v4";

export const getApiBookingIdPathParamsSchema = z.object({
    "id": z.coerce.number().int().describe("ID записи")
    }) as unknown as z.ZodType<GetApiBookingIdPathParams>

export const getApiBookingIdQueryParamsSchema = z.object({
    "branch_id": z.coerce.number().int().min(1).describe("ID филиала")
    }) as unknown as z.ZodType<GetApiBookingIdQueryParams>

/**
 * @description OK
 */
export const getApiBookingId200Schema = z.lazy(() => modelsAppointmentSchema) as unknown as z.ZodType<GetApiBookingId200>

export const getApiBookingIdQueryResponseSchema = z.lazy(() => getApiBookingId200Schema) as unknown as z.ZodType<GetApiBookingIdQueryResponse>